// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2tpqb","unreadBadge":"styles_unreadBadge__1nhET","modalContent":"styles_modalContent__3EBGt","modal":"styles_modal__3scBk"};